<template>
   <div class="form-body form-left">
        <div class="iofrm-layout">
            <div class="form-holder">
                <div class="form-content">
                    <div class="form-items">
                        <div class="website-logo-inside logo-normal">
                            <a href="/">
                                <div class="">
                                    <img style="max-width:300px !important;" class="" src="@/images/logo.png" alt="">
                                </div>
                            </a>
                        </div>
                        <Loading v-if="exibeLoading" />
                        <form v-if="!exibeLoading" class="mt-5" @submit.prevent="handleLogin">
                            <input :disabled="desabilitar" class="form-control" type="text" v-model="loginUser" placeholder="Seu E-mail">
                            <input :disabled="desabilitar" class="form-control" type="password" v-model="password" placeholder="***">
                            <div class="form-button d-flex">
                                <button :disabled="desabilitar" id="submit" type="submit" class="btn btn-primary">Acessar</button>
                            </div>
                        </form>
                        <Alert v-if="showMsg" :tipo="tipoExibe" :msg="msgExibe" />
                        <div v-if="msgNaoAutenticado" class="alert alert-danger">{{ msgNaoAutenticado }}</div>
                        <div class="other-links">
                            <span>Powered by <b>Junior</b></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref } from 'vue';
import login from '@/servicos/login';
import Loading from '@/components/Loading.vue';
import Alert  from '@/components/Alert.vue';
import router from "@/router";


const msgNaoAutenticado = ref(sessionStorage.getItem('naoConectado') ?? false)
const loginUser = ref('')
const password  = ref('')
const exibeLoading = ref(false)
const showMsg = ref(false)
const tipoExibe = ref('');
const msgExibe = ref('');
sessionStorage.clear()


const desabilitar = ref(false)

const handleLogin = async () => {
    exibeLoading.value = true
    const response = await login.verificaLogin(loginUser.value, password.value)
    if(response){
        exibeLoading.value = false
        showMsg.value = true
        tipoExibe.value = response.tipo,
        msgExibe.value = response.msg
        if(response.tipo == "success"){
            desabilitar.value = true
            localStorage.setItem('usuario', JSON.stringify(response.user))
            router.push('/dashboard')
        }
    }
}
</script>

